<template>
    <a-modal
      :title="$t('visitor-appointment-modal.header')"
      :visible="visible"
      :closable="false"
      :okText="$t('modal-btn.place-request')"
      :cancelText="$t('modal-btn.alter-cancel-btn-caption')"
      :confirm-loading="isLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >

        <h5 style="text-align: center;margin-bottom: 5px;">{{$t('visitor-appointment-modal.title')}}</h5>
        <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 10px;">
            <a-avatar
                slot="avatar"
                :size="64"
                shape="square"
                :src="officialImageUrl"
            />
            <div style="margin-left: 10px; display: flex; flex-direction: column; align-items: start; justify-content: space-around;">
                <h6 style="margin-bottom: 0px; !important">{{ officialName }}</h6>
                <p style="font-weight: 600;margin-top: 0px !important">{{ officialDesignation }}</p>
            </div>
        </div>
      
        
        <a-form
            id="take-appointment-logged-in-form"
            class="take-appointment-logged-in-form"
            style="min-height: 400px !important;">
        
        <a-form-item>	
                <!-- label="Appointment Type (*)"  -->
            <a-form-item
                :validate-status="validations.statusType"
                :help="validations.helpType">
                <label style="color:#000;font-weight: 600">{{$t('form-label.appointment-type')}} <b style="color:red">(*)</b></label>
                <a-select
                    v-model="type"
                    class="form-input"
                    show-search
                    :placeholder="$t('form-label.appointment-type')"
                    option-filter-prop="children">
                    <a-select-option value="ONLINE">
                        Online
                    </a-select-option>
                    <a-select-option value="IN_PERSON">
                        In Person
                    </a-select-option>
                </a-select>
            </a-form-item>
            
        </a-form-item>

        <a-form-item>
                <!-- label="Person Count (*)"  -->
            <a-form-item
                :validate-status="validations.statusPersonCount"
                :help="validations.helpPersonCount">
                <label style="color:#000;font-weight: 600">{{$t('form-label.person-count')}} <b style="color:red">(*)</b></label>
                <a-input
                    class="form-input"
                    :placeholder="$t('form-label.person-count')"
                    v-model="personCount"
                />
            </a-form-item>
        </a-form-item>
        
            <!-- label="Appointment Agenda (*)"   -->
        <a-form-item class="mb-5"
            :validate-status="validations.statusTopic"
            :help="validations.helpTopic">
            <label style="color:#000;font-weight: 600">{{$t('form-label.appointment-agenda')}} <b style="color:red">(*)</b></label>
            <a-textarea 
                :placeholder="$t('form-label.appointment-agenda')" :rows="4" v-model="topic"
            />
        </a-form-item>

    </a-form>

        
        
    </a-modal>
</template>
<script>

import { useLocaleStore } from "../../stores/locale-store.js";
import { mapActions, mapState } from 'pinia';
import { toastMixin } from '../../mixins/ToastMixin';
import { useAuthStore } from '../../stores/auth-store';
import { useVisitorAppointmentsStore } from '../../stores/visitor-appointments-store';



export default {
    props: {
        hour: {
            type: Number,
            required: false,
        },
        min: {
            type: Number,
            required: false,
        },
        date: {
            type: String,
            required: false
        }
    },
    components: {
        
    },
    mixins: [ toastMixin ],
    data() {
        return {
            title: 'Request Appointment',
            isLoading: false,
            visible: false,
            duration: '15',
            meetingLink: '',
            //--
            type: '',
            topic: '',
            personCount: '',
            selectedOfficial: {},
            selectedOfficialId: '',
            validations: {
                statusType: '',
                helpType: '',
                statusSelectedOfficial: '',
                helpSelectedOfficial: '',
                statusPersonCount: '',
                helpPersonCount: '',
                statusTopic: '',
                helpTopic: '',
            },
            isLoading: false,
            officials: [],
            allOfficials: []
        }
    },
    computed: {
        ...mapState(useAuthStore, [ 'profile'] ),
        ...mapState(useLocaleStore, [ 'locale' ]),
        officialImageUrl() {
            if (this.selectedOfficial && this.selectedOfficial.imageUrl && this.selectedOfficial.imageUrl.length > 0)
                return this.selectedOfficial.imageUrl;
            return '/images/default-avatar.jpg';
        },
        officialName() {
            if (this.locale == 'bn'){
                if (this.selectedOfficial && this.selectedOfficial.nameBn){ 
                    return this.selectedOfficial.nameBn;
                }
            }
            if (this.locale == 'en'){
                if (this.selectedOfficial && this.selectedOfficial.name){
                    return this.selectedOfficial.name;
                }
            }
            return "";
        },
        officialDesignation() {
            if (this.locale == 'bn')
                if (this.selectedOfficial && this.selectedOfficial && this.selectedOfficial.designation && this.selectedOfficial.designation.name)
                    return this.selectedOfficial.designation.nameBn;
            if (this.locale == 'en')
                if (this.selectedOfficial && this.selectedOfficial && this.selectedOfficial.designation && this.selectedOfficial.designation.name)
                    return this.selectedOfficial.designation.name;
            return '';
        }
    },
    methods: {
        ...mapActions(useVisitorAppointmentsStore, [ 'applyForAppointment' ]),
        clearValidations() {
            Object.keys(this.validations).forEach(key => {
                this.validations[key] = '';
            });
        },
        validate() {
  
            this.clearValidations();
            
            if (this.type.trim().length == 0) {
                this.validations.statusType = 'error';
                this.validations.helpType = 'Please select an Appointment Type';
                return false;
            }

            if (this.personCount.trim().length == 0 || isNaN(this.personCount)) {
                this.validations.statusPersonCount = 'error';
                this.validations.helpPersonCount = 'Please enter a valid person count';
                return false;
            }

            if (this.topic.trim().length == 0) {
                this.validations.statusTopic = 'error';
                this.validations.helpTopic = 'Please enter an Agenda for the appointment';
                return false;
            }

            return true;

        },
        handleOk() {
            // this.approveSelectedAppointment(this.hour, this.min, this.date, Number(this.duration));
            // this.visible = false;

            if (!this.validate()) {
                return;
            }
            if (this.selectedOfficial && this.selectedOfficial.id && this.selectedOfficial.id.length > 0 && this.profile && this.profile.id && this.profile.id.length > 0) {
                
                this.isLoading = true;

                let payload = {
                    appointment: {
                        officialId: this.selectedOfficial.id, 
                        type: this.type, 
                        topic: this.topic, 
                        visitorId: this.profile.id, 
                        personCount: Number(this.personCount)
                    },
                    official: this.selectedOfficial,
                    visitor: this.profile
                };

                this.applyForAppointment(payload).then(() => {
                    this.successToast('Successfully requested for Appointment');
                    this.visible = false;
                    this.isLoading = false;
                }).catch(error => {
                    if (error == 'network_error') {
                        this.errorToast('Network Error, Could not request for Appointment, please check network connection');    
                    } else {
                        this.errorToast('Error approving Appointment, status code :: ' + error);    
                    }
                    this.isLoading = true;
                    this.visible = false;
                });
            } else {
                this.errorToast('Your session expired, this might be due to server maintenance, Please logout and login again');    
            }
            
            
        },
        handleCancel() {
            this.visible = false;
        },
        showModal(official) {
            this.selectedOfficial = official;
            this.visible = true;
        }
    }
    
}
</script>